/** See `src/i18n/locales/en/subscription.ts` for context on the `// legal` keys. */
export const subscription = {
  title: 'Abonnement',
  lead: 'Gérez votre propre abonnement — plan, paiement et résiliation.',
  dialogCancel: 'Annuler',
  status: {
    title: 'Statut',
    active: 'Actif',
    inactive: 'Inactif',
    tier: 'Plan',
    expires: 'Expire le',
    autoRenews: 'Se renouvelle automatiquement',
    doesNotRenew: 'Ne se renouvelle pas',
    nextCharge: 'Prochain prélèvement',
    blocked: "Vous ne pouvez pas démarrer d'abonnement web pour le moment.",
  },
  plans: {
    title: 'Plans',
    monthly: 'Mensuel',
    yearly: 'Annuel',
    perMonth: '{{price}} / mois',
    perYear: '{{price}} / an',
    subscribe: "S'abonner",
    current: 'Plan actuel',
    switchToYearly: 'Passer à l’annuel',
    switchToMonthly: 'Passer au mensuel',
    // legal
    switchWarning:
      "Le changement résilie votre abonnement actuel et démarre le nouveau immédiatement sur le même mandat de paiement. Le chevauchement entre les deux périodes n'est pas crédité — vous pouvez être facturé deux fois pour cette période.",
    switchConfirm: 'Oui, changer de plan',
    blocked:
      'Vous avez déjà un abonnement actif, aucun autre plan ne peut donc être démarré maintenant.',
  },
  manage: {
    title: 'Gérer',
    cancel: "Résilier l'abonnement",
    cancelConfirm: 'Oui, résilier',
    cancelled: "Résilié — l'accès reste actif jusqu'au {{date}}.",
    // legal
    proRataNote:
      "Sur le plan annuel, une résiliation après la première période de paiement rembourse les mois complets non utilisés et met fin à l'accès immédiatement, au lieu d'attendre la fin de la période.",
    withdraw: 'Se rétracter (dans les 14 jours)',
    withdrawHint:
      'Disponible jusqu’à 14 jours après votre premier paiement, une seule fois, par abonnement.',
  },
  history: {
    title: 'Historique',
    empty: "Aucun achat pour l'instant.",
    date: 'Date',
    period: 'Période',
    channel: 'Canal',
    state: 'Statut',
    state_granted: 'Accordé',
    state_refunded: 'Remboursé',
    state_revoked: 'Révoqué',
    state_charged_back: 'Rétrofacturé',
    state_rejected: 'Refusé',
    invoice: 'Facture',
    withdrawLink: 'Se rétracter',
    manageLink: 'Gérer dans la boutique',
  },
  checkout: {
    title: 'Paiement',
    lead: 'Vérifiez votre plan avant de continuer vers Mollie.',
    plan: 'Plan',
    price: 'Prix',
    // legal — consentement §7.5 à l'exécution immédiate, repris du texte
    // néerlandais original de PLAN-FASE1.md.
    consentLabel:
      "Je souhaite que le service démarre immédiatement et je comprends qu'en cas de rétractation, je paierai au prorata de la partie déjà utilisée.",
    start: 'Continuer vers Mollie',
    errorAlreadySubscribed: 'Vous avez déjà un abonnement actif.',
    errorProductUnavailable: "Ce plan n'est pas disponible pour le moment.",
  },
  return: {
    title: 'Statut du paiement',
    waiting: 'Nous attendons encore la confirmation de votre paiement.',
    success: 'Paiement reçu — votre abonnement est actif.',
    backToSubscription: 'Retour à votre abonnement',
  },
  withdraw: {
    title: "Rétractation de l'abonnement",
    // legal — droit de rétractation (art. 6:230oa BW, NL).
    lead: "Vous rétracter dans votre délai de rétractation de 14 jours met fin à votre accès immédiatement — contrairement à la résiliation, qui court jusqu'à la fin de la période déjà payée.",
    refundTypeFull: 'Vous recevrez un remboursement intégral.',
    refundTypeProRata: 'Vous recevrez un remboursement au prorata de la partie non utilisée.',
    refundAmount: 'Montant remboursé',
    deadline: 'Date limite',
    confirm: "Se rétracter et mettre fin à l'accès maintenant",
    confirmed: 'Rétracté — {{amount}} sera remboursé.',
    errorWindowExpired: 'Le délai de rétractation de 14 jours est dépassé.',
    errorAlreadyWithdrawn: 'Vous vous êtes déjà rétracté de cet abonnement.',
  },
} as const;
